module.exports = __webpack_public_path__ + "img/flag_us.f4011b80.jpg";